<template>
  <div class="main">
    <Waiting
      ref="waiting"/>
    <AccountIsUnsubscribedAdv
      ref="AccountIsUnsubscribedAdv"/>
    <div>
      <div class="small_main_container" id="successActivate">
        <div>
          <div>
            Poprawnie dezaktywowano subskrybuję powiadomień marketingowych
          </div>
          <i class="far fa-check-circle" style="font-size: 40px"></i>
          <div class="smallText">
            <div>
              Proces dezaktywacji subskrypcji powiadomień marketingowych zakończył sie poprawnie.
              Celem ponownej aktywacji należy skorzystać z panelu ustawień.
              Zachęcamy do polubienia nas na Facebooku oraz Instagramie.
            </div>
            <div class="social">
              <div class="social facebook" @click="globalGoTo('https://www.facebook.com/TaPo24/','Link do strony ', 'web', 'SOCIAL')">
                <div class="icon social facebook"><span><i class="fab fa-facebook-f"></i></span></div>
              </div>
              <div class="social instagram" @click="globalGoTo('https://www.instagram.com/tapo24.pl/','Link do strony IG', 'web', 'SOCIAL')">
                <div class="icon social instagram"><span><i class="fab fa-instagram"></i></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" @click="click_to_login" id="footerActivate2" v-if="uidExist">
        Zaloguj się <i class="fa-regular fa-hand-pointer"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AccountIsUnsubscribedAdv from '@/components/Register/AccountIsUnsubscribedAdv'
import Waiting from '@/components/Register/Waiting'

export default {
  name: 'UnsubscribeAdv.vue',
  components: { AccountIsUnsubscribedAdv, Waiting },
  data () {
    return {
      payloadActivateAccount: {
        dbid: 0,
        token: ''
      },
      uidExist: false
    }
  },
  methods: {
    click_to_login () {
      this.$router.push({ name: 'Login' })
    }
  },
  mounted () {
    this.$refs.waiting.showWaiting()
  },
  created () {
    const UID = localStorage.getItem('UID')
    if (UID) {
      this.uidExist = true
    }
    this.payloadActivateAccount.dbid = this.$route.params.dbid
    this.payloadActivateAccount.token = this.$route.params.token
    const headers = {
      'Content-Type': 'application/json',
      'INSTALLATION-UID': this.$route.params.uid
    }
    axios
      .post(this.$store.state.path_api + '/register/unsubscribe_Adv', this.payloadActivateAccount, { headers })
      .then(response => {
        document.getElementById('successActivate').style.display = 'flex'
        document.getElementById('successActivate').style.visibility = 'unset'
        document.getElementById('footerActivate2').style.display = 'flex'
        document.getElementById('footerActivate2').style.visibility = 'unset'
        this.$refs.waiting.hideWaiting()
      })
      .catch(error => {
        if (error.response.data === 'Adv now is unsubscribed') {
          this.$refs.waiting.hideWaiting()
          this.$refs.AccountIsUnsubscribedAdv.showSuccess()
        } else {
          this.$refs.waiting.hideWaiting()
          this.$store.state.error = error
          this.$store.state.proces_Name = 'Account unsubscribe adv'
          this.$store.state.error_response = error.response
          this.$store.state.error_message = error.response.data
          this.$router.push({ name: 'ErrorPage', params: { dbid: this.dbid } })
        }
      })
  }
}
</script>

<style scoped lang="scss">
@import "@/views/main_layout.scss";
@import "@/views/others.scss";

#successActivate {
  font-family: $text-family;
  display: none;
  visibility: hidden;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
}
#footerActivate2 {
  display: none;
  justify-content: center;
  visibility: hidden;
}
.smallText {
  font-size: 12px;
  overflow-wrap: normal;
}
.social{
  display: inline-flex;
  list-style: none;
}
.social .icon{
  background: #293241;
  color: #ee6c4d;
  border-radius: 50%;
  padding: 5px;
  width: 15px;
  height: 15px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.footer{
  margin: 10px 10px;
  width: auto;
  background-color: #3D5A80;
  border-radius: 8px;
  padding: 20px 10px;
  height: min-content;
  font-family: $text-family;
  font-weight: bold;
  text-align: center;
  transition: 0.5s;
}
.footer:hover {
  cursor: pointer;
  background-color: #9cbad3;
}
@media only screen and (min-width: 700px) {
  .small_main_container {
    width: 400px;
  }
}
</style>
